export class GraphQLResponse {
  data?: any;

  constructor(data?: any) {
    this.data = data;
  }
}



// WEBPACK FOOTER //
// ./src/utils/networking/GraphQLResponse.ts